// Put all packages together.
// Used to generate umd/index.prod.js

import React from 'react';
import { createRoot } from 'react-dom/client';

import { IntlProvider } from 'react-intl';

import TinodeWeb from '@views/tinode-web.jsx';
import { EN_LOCALE, localeForSite, normalizeLocale } from '@lib/site-locale.js';

// Allow loading translation strings for just one language.
const messageLoader = {
  ru: _ => import('./i18n.min/ru.json'),
  en: _ => import('./i18n.min/en.json'),
};

const language = localeForSite();

// Приводим имена вроде 'en_GB' и 'en-GB' к единому виду с '-'.
const normalized = normalizeLocale(language);
// Получаем базовый язык из более конкретной локали для частичного fallback.
const baseLanguage = normalized.split('-')[0];

// Сначала пробуем полную локаль, затем локаль без региона, затем EN_LOCALE.
const htmlLang = messageLoader[normalized] ? normalized : messageLoader[baseLanguage] ? baseLanguage : EN_LOCALE;

const html = document.getElementsByTagName('html')[0];
// Set lang attribute of the HTML element: <html lang="XX">
html.setAttribute('lang', htmlLang);
// Render the app.
const root = createRoot(document.getElementById('mountPoint'));
messageLoader[htmlLang]().then(messages =>
  root.render(
    <IntlProvider locale={language} messages={messages} textComponent={React.Fragment}>
      <TinodeWeb />
    </IntlProvider>
  )
);
